module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "special-bg"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgAddress + _vm.content.coverImgpath
    },
    on: {
      "error": function($event) {
        return _vm.error(5)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "main-width bg-color-white"
  }, [_c('div', {
    staticClass: "special-line special"
  }), _vm._v(" "), _vm._l((_vm.serialContent), function(item) {
    return _c('div', {
      staticClass: "special-bg img-padding"
    }, [(item.jumpStyle == 1) ? _c('div', [_c('a', [_c('img', {
      attrs: {
        "src": _vm.imgAddress + item.imagePath
      },
      on: {
        "error": function($event) {
          return _vm.error(6)
        }
      }
    })])]) : (item.jumpStyle == 2) ? _c('div', [_c('router-link', {
      attrs: {
        "tag": "a",
        "to": {
          name: 'Detail',
          query: {
            goodsId: item.jumpTo
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imgAddress + item.imagePath
      },
      on: {
        "error": function($event) {
          return _vm.error(6)
        }
      }
    })])], 1) : (item.jumpStyle == 3) ? _c('div', [_c('a', {
      attrs: {
        "href": item.jumpTo
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imgAddress + item.imagePath
      },
      on: {
        "error": function($event) {
          return _vm.error(6)
        }
      }
    })])]) : _c('div', [_c('a', [_c('img', {
      attrs: {
        "src": item.imagePath
      },
      on: {
        "error": function($event) {
          return _vm.error(6)
        }
      }
    })])])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8556f8b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Special.vue
// module id = 543
// module chunks = 1